import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { withAnonymousUserLayout } from 'acscp/components/layout/anonymousUserLayout';
import buttonStyle from 'acscp/components/common/buttons.module.scss';
import { FullPageMessage } from 'acscp/components/common/fullPageMessage';
import { home } from 'acscp/components/routeHelper';

const createErrorPage = (title: JSX.Element, message: JSX.Element): React.ComponentType => withAnonymousUserLayout(() => (
    <FullPageMessage
        title={title}
        message={message}
        buttons={
            <Link className={buttonStyle.BasicButton} to={home()}>
                <FormattedMessage
                    id={'web.components.pages.errorPage.homeButton'}
                    defaultMessage={'Back to Home Page'}
                />
            </Link>
        }
    />
));

const NotFound = createErrorPage(
    <FormattedMessage id={'web.components.notFound.header'} defaultMessage={'Page not found'} />,
    (
        <FormattedMessage
            id={'web.components.notFound.body'}
            defaultMessage={'Sorry, we can\'t find that page! It might be an old link or maybe it moved.'}
        />
    )
);

const ServerError = createErrorPage(
    <FormattedMessage id={'web.components.serverError.header'} defaultMessage={'Server error'} />,
    (
        <FormattedMessage
            id={'web.components.serverError.body'}
            defaultMessage={'Something went wrong. Please try again.'}
        />
    )
);

const UnsharedLink = createErrorPage(
    <FormattedMessage id={'web.components.unsharedLink.header'} defaultMessage={'Link deactivated'} />,
    (
        <FormattedMessage
            id={'web.components.unsharedLink.body'}
            defaultMessage={'This link has been deactivated by the account holder.'}
        />
    )
);

export { NotFound, ServerError, UnsharedLink };
